document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('#shopify-section-sections--16432634003541__icon_with_text_RYCaRH');
  const sectionOffsetTop = section.offsetTop;

  window.addEventListener('scroll', function () {
    if (window.scrollY >= sectionOffsetTop) {
      section.classList.add('sticky-on-top');
    } else {
      section.classList.remove('sticky-on-top');
    }
  });
    });